import { createContext, ReactNode, FC } from "react";

import { useProductManagement } from "../hooks/useProductManagement";

type ProductManagementContextType = ReturnType<typeof useProductManagement>;

export const ProductManagementContext = createContext<ProductManagementContextType | undefined>(undefined);

interface ProductManagementProviderProps {
  children: ReactNode;
}

export const ProductManagementProvider: FC<ProductManagementProviderProps> = ({ children }) => {
  const productManagement = useProductManagement();

  return (
    <ProductManagementContext.Provider value={productManagement}>
      {children}
    </ProductManagementContext.Provider>
  );
};
